module.exports = __webpack_public_path__ + "img/c19.4e3ac44c.png";